import { Button } from '@pms-digital/design-system';

export interface SetupImportSourceBarProps {
  /** File name, or « Cellules collées ». */
  label: string;
  /** Sheets holding a setup table; the selector shows when there are several. */
  candidateSheets?: string[];
  sheetName?: string | null;
  onSheetChange?: (sheetName: string) => void;
  onChangeSource: () => void;
}

/** The « Source » line of the preview and refusal states (boards 03 and 04). */
export function SetupImportSourceBar({
  label,
  candidateSheets = [],
  sheetName = null,
  onSheetChange,
  onChangeSource,
}: SetupImportSourceBarProps) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-3 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-small">
      <span>Source :</span>
      <span className="font-semibold" data-testid="setup-import-source">
        {label}
      </span>
      {sheetName !== null && candidateSheets.length > 1 && (
        <>
          <span>· feuille</span>
          <select
            aria-label="Feuille"
            value={sheetName}
            onChange={(event) => onSheetChange?.(event.target.value)}
            className="rounded-md border-2 border-gray-200 bg-white px-2 py-1 text-small focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bleu-nuit"
          >
            {candidateSheets.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
          <span className="text-caption text-gray-500">
            {candidateSheets.length} feuilles contiennent un tableau de setup
          </span>
        </>
      )}
      {sheetName !== null && candidateSheets.length <= 1 && <span>· feuille {sheetName}</span>}
      <span className="flex-1" aria-hidden="true" />
      <Button type="button" variant="ghost" size="sm" onClick={onChangeSource}>
        Changer de source
      </Button>
    </div>
  );
}
